<template>
  <div class="container-fluid">
    <div class="d-flex gap-2 mt-3">
      <div class="">
        <div class="input-group">
          <RouterLink :to="{ name: 'info' }" class="btn btn-outline-secondary">
            <font-awesome-icon :icon="['fas', 'chevron-left']" />
            {{ $t('action.back') }}
          </RouterLink>
        </div>
      </div>
      <div class="fs-2">{{ $t('menu.info-device') }}</div>
    </div>
    <div class="card mt-3 mel-glass-panel">
      <h4 class="card-header">{{ $t('page.device.screen') }}</h4>
      <div class="card-body">
        <dl class="mb-0">
          <dt>{{ $t('page.device.displayResolution') }}</dt>
          <dd>{{ resolutionSize }} @{{ dpr }}</dd>
          <dt>{{ $t('page.device.displayViewport') }}</dt>
          <dd>{{ viewportSizeString }}</dd>
        </dl>
      </div>
    </div>
    <div class="card mt-3 mel-glass-panel">
      <h4 class="card-header">{{ $t('page.device.network') }}</h4>
      <div class="card-body">
        <dl class="mb-0">
          <dt>{{ $t('page.device.remoteAddress') }}</dt>
          <dd>{{ remoteAddress }}</dd>
          <dt>{{ $t('page.device.userAgent') }}</dt>
          <dd>{{ userAgent }}</dd>
        </dl>
      </div>
    </div>
    <div class="mt-3"></div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { onMounted, onUnmounted } from 'vue';
import api from '@/services/api';
import type IClientInfo from '@/models/responses/IClientInfo';

const viewportSize = ref({ width: window.innerWidth, height: window.innerHeight });
const clientInfo = ref<IClientInfo | null>(null);

let authenticatorInterval: ReturnType<typeof setInterval> | undefined;

onMounted(async () => {
  window.addEventListener('resize', recalculateViewportSize);
  await fetchClientInfo();
});

onUnmounted(() => {
  if (authenticatorInterval) {
    clearInterval(authenticatorInterval);
  }
  authenticatorInterval = undefined;
  window.removeEventListener('resize', recalculateViewportSize);
});

const fetchClientInfo = async () => {
  try {
    const response = await api.get<IClientInfo>('v1.0/setup/client-info');
    clientInfo.value = response.data;
  } catch (error) {
    console.error('Failed to fetch client info:', error);
  }
};

const recalculateViewportSize = () => {
  viewportSize.value = {
    width: window.innerWidth,
    height: window.innerHeight
  };
};

const resolutionSize = computed(() => {
  const width = window.screen.width;
  const height = window.screen.height;
  return `${width}x${height}`;
});

const dpr = computed(() => {
  return `${window.devicePixelRatio.toFixed(2)}`;
});

const viewportSizeString = computed(() => {
  return `${viewportSize.value.width}x${viewportSize.value.height}`;
});

const remoteAddress = computed(() => {
  return clientInfo.value?.remoteIpAddress ?? 'N/A';
});

const userAgent = computed(() => {
  return clientInfo.value?.userAgent ?? 'N/A';
});
</script>

<style lang="scss" scoped>
.table th,
.table td {
  background-color: transparent !important;
}

.card-header {
  cursor: default;
  user-select: none;
}
</style>
